import * as React from 'react';
import type { OwaDate } from 'owa-datetime';
import { WeatherSurfaceItem } from 'owa-weather';

const styles = require('./CalendarPaneHeaderWeather.scss');

export default function CalendarPaneHeaderWeather({ date }: { date: OwaDate }) {
    return (
        <div className={styles.weatherIcon}>
            <WeatherSurfaceItem date={date} />
        </div>
    );
}
